import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as currentRendering from '../../../feature'
import type { Feature } from '../feature'
import { State } from '../state'

export const resetOnPageRender = store.reducers.extra(
  (feature: Feature, currentRenderingFeature: currentRendering.Feature) =>
    new store.reducers.ExtraReducer({
      on: [currentRenderingFeature.actions.render.request],
      reduce: () => State.INITIAL,
    }),
)
